import { CfServiceCardProps } from "./schema";
import CfCardGeneric from "components/Cards/CardGeneric/CfCardGeneric";
import React from "react";
import ServiceCard, { ServiceCardProps } from "../index";

export const convertCfServiceCardProps = ({
  cardContent,
}: CfServiceCardProps) => {
  const props: ServiceCardProps = {
    children: <CfCardGeneric {...cardContent} />,
  };
  return props;
};

const CfServiceCard = (props: CfServiceCardProps) => {
  return <ServiceCard {...convertCfServiceCardProps(props)} />;
};

export default CfServiceCard;
